import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { setTag } from "@sentry/react";
import { createContext, useCallback, useEffect, useState } from "react";
import { teamAliasMappings } from "../data/TeamAliasMappings.js";
export var OwnershipContext = /*#__PURE__*/ createContext({
    backendOwner: null,
    framework: null,
    frontendOwner: null,
    update: function() {
        return undefined;
    }
});
export var OwnershipProvider = function(param) {
    var children = param.children, defaultOwner = param.defaultOwner, defaultFramework = param.defaultFramework;
    var _defaultOwner;
    var resolvedDefaultOwner = defaultOwner ? (_defaultOwner = teamAliasMappings[defaultOwner]) !== null && _defaultOwner !== void 0 ? _defaultOwner : defaultOwner : null;
    var ref = _sliced_to_array(useState({
        backendOwner: null,
        framework: defaultFramework !== null && defaultFramework !== void 0 ? defaultFramework : null,
        frontendOwner: resolvedDefaultOwner
    }), 2), ref1 = ref[0], backendOwner = ref1.backendOwner, framework = ref1.framework, frontendOwner = ref1.frontendOwner, setOwnership = ref[1];
    var update = useCallback(function(newOwnership) {
        var _backendOwner, _frontendOwner;
        var normalizedOwnership = {
            backendOwner: newOwnership.backendOwner ? (_backendOwner = teamAliasMappings[newOwnership.backendOwner]) !== null && _backendOwner !== void 0 ? _backendOwner : newOwnership.backendOwner : null,
            framework: newOwnership.framework,
            frontendOwner: newOwnership.frontendOwner ? (_frontendOwner = teamAliasMappings[newOwnership.frontendOwner]) !== null && _frontendOwner !== void 0 ? _frontendOwner : newOwnership.frontendOwner : null
        };
        setOwnership(normalizedOwnership);
    }, []);
    useEffect(function() {
        if (frontendOwner) {
            setTag("frontendOwner", frontendOwner);
        }
    }, [
        frontendOwner
    ]);
    return /*#__PURE__*/ _jsx(OwnershipContext.Provider, {
        value: {
            backendOwner: backendOwner,
            framework: framework,
            frontendOwner: frontendOwner,
            update: update
        },
        children: children
    });
};

//# sourceMappingURL=OwnershipContext.js.map